export const getCaseImage = (caseImage: string, mana: boolean) => {
  return process.env.NODE_ENV === 'development'
    ? (!mana ? require(`@/assets/img/samples/cases/${Math.floor(Math.random() * 3) +
        1}.png`) : require('@/assets/img/samples/case-mana.png'))
    : `/img/cases/${caseImage}`;
};
